import { render, staticRenderFns } from "./LookupSelector.vue?vue&type=template&id=2b7a233e&scoped=true"
import script from "./LookupSelector.vue?vue&type=script&lang=js"
export * from "./LookupSelector.vue?vue&type=script&lang=js"
import style0 from "./LookupSelector.vue?vue&type=style&index=0&id=2b7a233e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a233e",
  null
  
)

export default component.exports